import { createFileRoute } from "@tanstack/react-router";
import { VersichertenList } from "@/components/versicherte/VersichertenList";

export const Route = createFileRoute("/_authenticated/versicherte/")({
  component: VersicherteIndexPage,
});

function VersicherteIndexPage() {
  return <VersichertenList />;
}
